module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-79.e49a3d33.svg";